import type {
    ColourFromOtherGradesType,
    UpholsteryFromOtherGradesType,
    WheelFromOtherGradesType,
} from "../../../shared-logic/types/AvailableInOtherGradesType";
import type { GradeFeaturesType } from "../redux/slices/CarConfigGradesSlice";
import type { AvailableInOtherGradeModalType } from "./types/SectionTypes";
import type { MODAL_ERRORS, ModalErrorsType } from "../../../../common-deprecated/utils/modalConstants";
import type { StepsType } from "./tracking";
import type {
    MODAL_RETAILER_DEBUG,
    MODAL_RETAILER_EXTERNAL_QR_CODE,
    RetailerDebugModalType,
    RetailerExternalQrCodeModalType,
} from "../../../../shared-logic/features/retailer/utils/modalConstants";
import type { MotorizationType } from "../../../shared-logic/types/Motorization";

export const MODAL_ORDER_CHECKOUT = "orderCheckoutAph" as const;
export const MODAL_FINANCE_CALCULATOR = "financeCalculatorAph" as const;
export const MODAL_FINANCE_DISCLAIMER = "financeDisclaimerAph" as const;
export const MODAL_INSURANCE_CALCULATOR = "insuranceCalculatorAph" as const;
export const MODAL_INSURANCE_DISCLAIMER = "insuranceDisclaimerAph" as const;
export const MODAL_DEBUG_FINANCE = "debugFinanceAph" as const;
export const MODAL_HIGHLIGHT_FEATURE = "highlightFeatureAph" as const;
export const MODAL_OTHER_GRADE = "otherGradeAph" as const;
export const MODAL_DEBUG_CAR_INFO = "debugCarInfoAph" as const;
export const MODAL_FULLSCREEN_CAR_SPIN = "fullscreenCarSpin" as const;
export const MODAL_MOBILE_GRADE_SELECTOR_FILTER = "gradeSelectorFilter" as const;
export const MODAL_DEBUG_WINTER_WHEELS = "debugWinterWheelsAph" as const;

export type AphModalIdsType =
    | typeof MODAL_HIGHLIGHT_FEATURE
    | typeof MODAL_ORDER_CHECKOUT
    | typeof MODAL_FINANCE_CALCULATOR
    | typeof MODAL_FINANCE_DISCLAIMER
    | typeof MODAL_INSURANCE_CALCULATOR
    | typeof MODAL_INSURANCE_DISCLAIMER
    | typeof MODAL_DEBUG_FINANCE
    | typeof MODAL_HIGHLIGHT_FEATURE
    | typeof MODAL_OTHER_GRADE
    | typeof MODAL_DEBUG_CAR_INFO
    | typeof MODAL_ERRORS
    | typeof MODAL_RETAILER_DEBUG
    | typeof MODAL_RETAILER_EXTERNAL_QR_CODE
    | typeof MODAL_FULLSCREEN_CAR_SPIN
    | typeof MODAL_MOBILE_GRADE_SELECTOR_FILTER
    | typeof MODAL_DEBUG_WINTER_WHEELS;

export type OrderCheckoutModalType = {
    type: typeof MODAL_ORDER_CHECKOUT;
    checkoutType: "buy" | "reserve" | "lease";
};

export type HighlightFeatureModalType = {
    type: typeof MODAL_HIGHLIGHT_FEATURE;
    gradeFeature?: GradeFeaturesType;
};

export type FinanceCalculatorModalType = {
    type: typeof MODAL_FINANCE_CALCULATOR;
    origin?: "cc-cta" | "cc-navigation-top";
    step?: StepsType;
    injectionLoading?: boolean;
    injectionError?: boolean;
};

export type InsuranceCalculatorModalType = {
    type: typeof MODAL_INSURANCE_CALCULATOR;
    injectionLoading?: boolean;
    injectionError?: boolean;
};

export type FinanceDisclaimerModalType = {
    type: typeof MODAL_FINANCE_DISCLAIMER;
};

export type InsuranceDisclaimerModalType = {
    type: typeof MODAL_INSURANCE_DISCLAIMER;
};

export type DebugFinanceModalType = {
    type: typeof MODAL_DEBUG_FINANCE;
};

export type DebugCarInfoModalType = {
    type: typeof MODAL_DEBUG_CAR_INFO;
};

export type FullScreenExteriorModalType = {
    type: typeof MODAL_FULLSCREEN_CAR_SPIN;
};

export type OtherGradeModalType = {
    type: typeof MODAL_OTHER_GRADE;
    availableInOtherGradesProps: {
        section?: AvailableInOtherGradeModalType;
        motorization?: MotorizationType;
        colour?: ColourFromOtherGradesType;
        wheel?: WheelFromOtherGradesType;
        upholstery?: UpholsteryFromOtherGradesType;
    };
};

export type GradeSelectorFilterModalType = {
    type: typeof MODAL_MOBILE_GRADE_SELECTOR_FILTER;
};
export type DebugWinterWheelsModalType = {
    type: typeof MODAL_DEBUG_WINTER_WHEELS;
};

export type AphModalsType =
    | OrderCheckoutModalType
    | FinanceCalculatorModalType
    | FinanceDisclaimerModalType
    | InsuranceCalculatorModalType
    | InsuranceDisclaimerModalType
    | HighlightFeatureModalType
    | DebugFinanceModalType
    | OtherGradeModalType
    | DebugCarInfoModalType
    | ModalErrorsType
    | RetailerDebugModalType
    | RetailerExternalQrCodeModalType
    | FullScreenExteriorModalType
    | GradeSelectorFilterModalType
    | DebugWinterWheelsModalType;
